import axios from '../axios';
import { useMutation, useQuery } from 'react-query';

/** ******************* Corporate ******************************** */

// Add Corporate
export function useAddCorporateMutation() {
  // const axios = useAxios();
  return useMutation((corporate) => axios.post(`/corporate`, corporate), {
    onSuccess: (res) => ({ error: res.error, data: res.data }),
    onError: (err) => ({ data: err.response.data }),
  });
}

// Edit Corporate
export function useEditCorporateMutation() {
  // const axios = useAxios();
  return useMutation((corporate) =>
    axios.put(`/corporate/${corporate.ID}`, corporate),
  );
}

// List Corporates
export function useFetchCorporates() {
  // const axios = useAxios();
  return useQuery(['corporate/list'], () =>
    axios.get(`/corporate`).then((result) => result.data),
  );
}

// Get Corporate By Id
export function useFetchCorporateByID(cid) {
  // const axios = useAxios();
  return useQuery(['corporate/id', cid], () =>
    axios.get(`/corporate/${cid}`).then((result) => result?.data),
  );
}

/** ******************* Corporate Plans ******************************** */

// Add Corporate Plan
export function useAddCorporatePlanMutation() {
  // const axios = useAxios();
  return useMutation(
    (corporatePlan) => axios.post(`/corporatePlan`, corporatePlan),
    {
      onSuccess: (res) => ({ error: res.error, data: res.data }),
      onError: (err) => ({ data: err.response.data }),
    },
  );
}

// Edit Corporate Plan
export function useEditCorporatePlanMutation() {
  // const axios = useAxios();
  return useMutation((corporatePlan) =>
    axios.put(`/corporatePlan/${corporatePlan.ID}`, corporatePlan),
  );
}

// List Corporate Plans
export function useFetchCorporatePlans(coporateId) {
  // const axios = useAxios();
  return useQuery(['/corporate/plan'], () =>
    axios.get(`/corporate/plan`).then((result) => result.data),
  );
}

// Get Corporate Plan By Id
export function useFetchCorporatePlanByID(pid) {
  // const axios = useAxios();
  return useQuery(['corporatePlan/id', pid], () =>
    axios.get(`/corporatePlan/${pid}`).then((result) => result?.data),
  );
}

/** ******************* Corporate Group ******************************** */

// Add Corporate Group
export function useAddCorporateGroupMutation() {
  return useMutation(
    (corporateGroup) => axios.post(`/corporateLocation`, corporateGroup),
    {
      onSuccess: (res) => ({ error: res.error, data: res.data }),
      onError: (err) => ({ data: err.response.data }),
    },
  );
}

// Edit Corporate Group
export function useEditCorporateGroupMutation() {
  // const axios = useAxios();
  return useMutation((corporateGroup) =>
    axios.put(`/corporateLocation/${corporateGroup.ID}`, corporateGroup),
  );
}

// List Corporate Groups
export function useFetchCorporateGroups(IS_CORPORATE_ADMIN = true) {
  // const axios = useAxios();

  return useQuery(
    ['corporateLocation/list'],
    () => axios.get(`/corporate/location`).then((result) => result.data),
    {
      enabled: IS_CORPORATE_ADMIN,
    },
  );
}

// Get Corporate Group By Id
export function useFetchCorporateGroupByID(cgid) {
  // const axios = useAxios();
  return useQuery(['corporateLocation/id', cgid], () =>
    axios.get(`/corporateLocation/${cgid}`).then((result) => result?.data),
  );
}

/** ******************* Corporate Single Matrix ******************************** */

// Get Corporate Single Matrix
export function useFetchCorporateSingleMatrix() {
  return useQuery(['corporateSingleMatrics'], () =>
    axios
      .get('/corporate/corporateSingleMatrics')
      .then((result) => result?.data),
  );
}
